/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Price_Per_LbInputs */

const en_cargos_price_per_lb = /** @type {(inputs: Cargos_Price_Per_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price/lb`)
};

const es_cargos_price_per_lb = /** @type {(inputs: Cargos_Price_Per_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio/lb`)
};

/**
* | output |
* | --- |
* | "Price/lb" |
*
* @param {Cargos_Price_Per_LbInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_price_per_lb = /** @type {((inputs?: Cargos_Price_Per_LbInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Price_Per_LbInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_price_per_lb(inputs)
	return es_cargos_price_per_lb(inputs)
});